export enum NotificationType {

  CONSULTANT_CREATED,
  CONSULTANT_EMAIL_ADDED,
  CONSULTANT_EMAIL_REMOVED,
  CONSULTANT_USERROLE_ADDED,
  CONSULTANT_USERROLE_REMOVED,
  CONSULTANT_APPOINTMENT_UPDATED,
  ORGANIZATION_ANNUAL_REPORT_UPLOADED,
  ORGANIZATION_FINANCIAL_REPORT_UPLOADED,
  ORGANIZATION_QUARTERLY_NOTIFICATION,
  ORGANIZATION_CHANGES_NOTIFICATION

}
